import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import * as API from './api/authentication-api';
import {getLoggedUserData} from "./api/authentication-api";
import {IUser} from "../../pages/user-management/models/User";
import { State } from '../../components/organisms/Cards/user-card-controller/types';


export interface AuthenticationState {
    clients:any,
    status: 'idle' | 'loading' | 'failed';
    isAuthenticated:boolean,
    loggedUser:IUser,
    token:string,
    userTypes:any,
    userStatus:any,
}

const initialState : AuthenticationState = {
    clients:[],
    status:"idle",
    isAuthenticated:false,
    loggedUser:{
        id: "",
        firstName:"",
        lastName:"",
        name: "",
        userName:"",
        email: "",
        status:"",
        image:"",
        designation:"",
        jobTitle:"",
        password:"",
        groupType:"",
        companyName:"",
        mobileNumber:"",
        state: State.Inactive,
        profileImage:"",
        createdBy: "",
        createdDate: "",
        modifiedBy:"",
        modifiedDate: "",
        userRole:"",
        passwordHash:"",
        userId:"",
        profilePicture:""
    },
    token:"",
    userTypes:[],
    userStatus:[]
}

export const clients = createAsyncThunk(
    'authentication/client',
    async () => {
        try{
            return await API.getClients();
        } catch (error) {
            throw error;
        }
    }
);

export const login = createAsyncThunk(
    'authentication/login',
    async (user: any) => {
        try{
            return await API.signIn(user);
        }catch (error) {
            throw error;
        }
    }
)

export const signUp = createAsyncThunk(
    'authentication/signUp',
    async ({user, url, accessToken}: {user:IUser,url: string; accessToken: string}) => {
        try{
            return await API.signUp(user, url, accessToken);
        }catch (error) {

            throw error;
        }
    }
)

export const getLoggedUser = createAsyncThunk(
    'authentication/loggedUse',
    async ({username, token} :{username:string, token:string}) => {
        try{
            return await API.getLoggedUserData(username, token);
        }catch (error) {
            throw error;
        }
    }
)

export const getUserType = createAsyncThunk(
    'authentication/userTypes',
    async (token:string) => {
        try {
            return await API.getUserTypes(token)
        }catch (e) {
            throw e;
        }
    }
)

export const getUserStatus = createAsyncThunk(
    'authentication/userStatus',
    async (token:string) => {
        try {
            return await API.getUserStatus(token)
        }catch (e) {
            throw e;
        }
    }
)


const AuthenticationSlice = createSlice({
    name:'authentication',
    initialState,
    reducers:{
        setLogout: (state, { payload }: PayloadAction) => {
            state.isAuthenticated = false;
            state.loggedUser = {  id: "",
                firstName:"",
                lastName:"",
                name: "",
                userName:"",
                email: "",
                status:"",
                image:"",
                designation:"",
                jobTitle:"",
                password:"",
                groupType:"",
                companyName:"",
                mobileNumber:"",
                profileImage:"",
                createdBy: "",
                createdDate: "",
                modifiedBy:"",
                modifiedDate: "",
                userRole:"",
                state:State.Inactive,
                userId:"",
                profilePicture:"",
                passwordHash:""};
            state.token = "";
            localStorage.clear();
        },
        checkAuthentication:(state, { payload }: PayloadAction) =>{
            if (localStorage.getItem('token')){
                state.isAuthenticated = true;
            }
        },
        selectedToken: (state, action: PayloadAction<any>) => {
            state.token = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(clients.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(clients.fulfilled, (state,{payload}) => {
                state.status = 'idle';
                state.clients = payload.data;
            })
            .addCase(clients.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(login.pending, (state) => {
                    state.status = 'loading';
                })
            .addCase(login.fulfilled, (state,{payload}) => {
                state.isAuthenticated = true;
                // state.token = payload.data.token;
                // localStorage.setItem('token', payload.data.token);
                // localStorage.setItem('user', payload.data.username);
                state.status = 'idle';
            })
            .addCase(login.rejected, (state,{payload}) => {
                state.status = 'failed';
            })
            .addCase(getUserType.pending, (state) => {
                state.status = 'loading';
                })
            .addCase(getUserType.fulfilled, (state,{payload}) => {
                state.userTypes = payload.data;
                localStorage.setItem('userTypes', JSON.stringify(payload.data));
                state.status = 'idle';
            })
            .addCase(getUserType.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getUserStatus.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getUserStatus.fulfilled, (state,{payload}) => {
                state.userStatus = payload.data;
                localStorage.setItem('userStatus', JSON.stringify(payload.data));
                state.status = 'idle';
            })
            .addCase(getUserStatus.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getLoggedUser.pending, (state) => {

            })
            .addCase(getLoggedUser.fulfilled, (state,{payload}) => {
                state.loggedUser = payload.data;
                state.status = 'idle';
                localStorage.setItem("userRole", payload.data.userRole)
            })
            .addCase(getLoggedUser.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(signUp.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(signUp.fulfilled, (state,{payload}) => {
                state.status = 'idle';
            })
            .addCase(signUp.rejected, (state) => {
                state.status = 'failed';
            })
    },
})

export const {setLogout, checkAuthentication, selectedToken} = AuthenticationSlice.actions;
export default AuthenticationSlice.reducer;